import React, { useContext, ComponentType } from 'react';
import { connect } from 'react-redux';
import store2 from 'store2';
import { ITranslateProps, translate } from '../mixins/translate';
import { check, tempLogin } from '../store/authentication/actions';
import { IConnectProps } from '../utils/IConnectProps';
import { appContext } from './appContext';
import { Logo } from './Logo';
import { Spinner } from './spinners';

interface ITempLoginProps extends ITranslateProps {
    code: string;
    loginFailed: boolean;
    signature: string;
    surveyId: string;
    loggedIn: boolean;
}

function mapStateToProps(state: any) {
    const { authentication } = state;
    return {
        loginFailed: authentication.failed,
        loggedIn: authentication.loggedIn,
        code: authentication.code,
    };
}

function TempLoginHeader() {
    const currentAppContext = useContext(appContext.context);
    const { customerVersion } = currentAppContext.globalSettings;
    if (customerVersion === 'ronik') {
        return null;
    }

    return (
        <div className="panel-header">
            <div className="pl25 pt5 pb5">
                <h2 className="h3 fw200">ZXY-Cloud login</h2>
            </div>
        </div>
    );
}

class TempLoginComponent extends React.Component<ITempLoginProps> {
    public override async componentDidMount() {
        await this.tempLogin();
    }

    public override async componentDidUpdate(prevProps: ITempLoginProps) {
        if (prevProps.loggedIn !== this.props.loggedIn) {
            await this.tempLogin();
        }
    }

    public override render() {
        return (
            <div className="external-page external-alt">
                <div id="main" className="">
                    <section id="content">
                        <div className="admin-form theme-info mw500" id="login">
                            <div className="row table-layout">
                                <Logo />
                            </div>

                            <div className="panel mt30 mb25">
                                <form method="get" id="login">
                                    <TempLoginHeader />
                                    <div className="panel-body bg-light p25 pb15">
                                        <p>
                                            {this.props.loginFailed ? (
                                                <>{this.props.t('login.tempLoginFailed')}</>
                                            ) : (
                                                <>
                                                    {this.props.t('login.tempLogin')}
                                                    <div className="ml40">
                                                        <Spinner />
                                                    </div>
                                                </>
                                            )}
                                        </p>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        );
    }

    private async tempLogin() {
        if (this.props.loggedIn) {
            await (this.props as unknown as IConnectProps).dispatch(check(false));
            window.location.replace(`/surveys/${this.props.surveyId}?templogin=true`);
        } else {
            store2.clearAll();
            await (this.props as unknown as IConnectProps).dispatch(tempLogin(this.props.signature, this.props.surveyId));
        }
    }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const TempLogin = translate()(
    connect(mapStateToProps)(TempLoginComponent) as ComponentType<Omit<ITempLoginProps, keyof ReturnType<typeof mapStateToProps>>>,
);

export { TempLogin };
